export default __webpack_public_path__ + "static/media/active-link-mark.644ac3c8.svg";